export default {
  name: 'marking--nkMappingUpload',
  apiService: 'shoes',
  apiPath: '/admin/nk_mapping/upload',
  urlParamName: 'marking--nkMappingUpload',
};